import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { StyledLink } from './Link';

type TContactLink = {
  href: string;
  prefix?: string;
} & JSX.IntrinsicElements['a'];

const LinkWrapper = styled.a`
  ${StyledLink.__emotion_styles}

  display: flex;
  flex-direction: column;
  row-gap: 0.75rem;
`;

const Label = styled.span`
  ${({ theme: { colors } }) => css`
    color: ${colors.offWhite};
  `}
`;

const ContactLink: React.FC<PropsWithChildren<TContactLink>> = ({ children, href, prefix }) => (
  <LinkWrapper href={`${prefix}${href}`}>
    <Label>{children}</Label>
    <span>{href}</span>
  </LinkWrapper>
);

export default ContactLink;
